import "@/index.css";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import HikariSaathi from "@/components/HikariSaathi";
import AdminDashboard from "@/components/AdminDashboard";
import OrgLogin from "@/components/OrgLogin";
import OrgDashboard from "@/components/OrgDashboard";
import { PrivacyPolicy, Terms } from "@/components/LegalPage";

function OrgSaathi() {
  const { slug } = useParams();
  return <HikariSaathi orgSlug={slug} />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HikariSaathi />} />
        <Route path="/o/:slug" element={<OrgSaathi />} />
        <Route path="/org/login" element={<OrgLogin />} />
        <Route path="/org" element={<OrgDashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </BrowserRouter>
  );
}
